import * as SendBird from 'sendbird';

export const sb = new SendBird({ appId: process.env.VUE_APP_SENDBIRD_APP_ID });

export default sb;
